import { render, staticRenderFns } from "./ManagementDetails.vue?vue&type=template&id=110e2f60"
import script from "./ManagementDetails.vue?vue&type=script&lang=js"
export * from "./ManagementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports